export const REVIEW_STATUSES = ['PENDING', 'APPROVED', 'REJECTED'] as const;
export type ReviewStatus = (typeof REVIEW_STATUSES)[number];

export const DECISIONS = ['APPROVED', 'REJECTED'] as const;
export type Decision = (typeof DECISIONS)[number];

export function isPending(status: ReviewStatus): boolean {
  return status === 'PENDING';
}

export interface Decided {
  status: ReviewStatus;
  decidedBy: string | null;
}

export const alreadyDecided = (subject: string, decision: Decision): string =>
  `${subject} is already ${decision}`;

export const decidedSince = (subject: string, row: Decided, page: string): string =>
  `${subject} was already decided (${row.status}${row.decidedBy ? ` by ${row.decidedBy}` : ''})` +
  ` — decide again from the ${page} page to change it`;
